import React from 'react';
import Info from 'oldAssets/images/icons/info.svg';
import styles from './InfoIcon.module.scss';

const InfoIcon = <span className={ styles.InfoIcon }><img src={ Info } /></span>;
 
export { InfoIcon };
